<template>
    <Layout>
      <PageHeader :title="title" :items="items" />
  
      <div class="row">
        <div class="col-12">
          <div class="card">
            <div class="card-body">
              <div class="mb-2 d-flex justify-content-md-start">
                <div class="form-group">
                <label>Date From</label>
                <input v-model="datefrom" type="date" class="form-control" />
                </div>
                <div class="form-group ms-2">
                <label>Date To</label>
                <input v-model="dateto" type="date" class="form-control" />
                </div>
                <span><br><b-button @click="FilterData" class="mt-2 ms-2" variant="primary"><i class="mdi mdi-filter"></i> Filter</b-button></span>
              </div>
              <div class="clearfix"></div>
              <div class="row">
                <div class="col-sm-12 col-md-6">
                  <div id="tickets-table_length" class="dataTables_length">
                    <label class="d-inline-flex align-items-center">
                      Show <b-form-select class="form-select form-select-sm mx-1" v-model="perPage" size="sm" :options="Options"></b-form-select> entries
                    </label>
                  </div>
                </div>
                <div class="col-sm-12 col-md-6">
                  <div id="tickets-table_filter" class="dataTables_filter text-md-end" >
                    <label class="d-inline-flex align-items-center">
                      Search: <b-form-input v-model="filter" type="search" placeholder="Search..." class="form-control form-control-sm ms-2"></b-form-input>
                    </label>
                  </div>
                </div>
              </div>
              <div class="table-responsive">
                <b-table
                  :items="Items"
                  :fields="Fields"
                  responsive="sm"
                  :per-page="perPage"
                  :current-page="currentPage"
                  :filter="filter"
                  :filter-included-fields="filterOn"
                  @filtered="Filtered"
                  :busy="IsBusy"
                >
                <template #table-busy><div class="text-center text-primary my-2"><b-spinner class="align-middle" type="grow" small></b-spinner> <strong>No Data Found</strong></div></template>
                <template #cell(index)="data">
                  {{ data.index + 1 }}
                </template>
                <template #cell(acc_name)="data">
                  {{ data.item.groupaccount.acc_name }}
                </template>
                <template #cell(acc_number)="data">
                  {{ data.item.groupaccount.acc_number }}
                </template>
                <template #cell(payment)="data">
                  {{ commas(data.item.payment) }}
                </template>
                <template #cell(paid)="data">
                  {{ commas(data.item.paid) }}
                </template>
                <template #cell(balance)="data">
                  <span v-if="data.item.balance>0">
                  {{ commas(data.item.balance) }} <br>
                    <b-button @click="pay(data.item.groupaccount.acc_name,data.item.groupaccount.acc_number,data.item.balance)" type="button" class="btn-sm btn" variant="primary" v-b-modal.edit> <i class="mdi mdi-cash"></i> pay</b-button>
                  </span>
                  <span v-else class="text-primary">
                      <i class="fas fa-check"></i> Paid
                  </span>
                </template>
                <template #cell(details)="data">
                  <div class="btn-group">
                    <router-link :to="{ path: '/accountmembersinvoice',  query: { id: data.item.groupaccount.acc_number }}" type="button" class="btn-sm btn btn-primary"> <i class="fas fa-edit"></i></router-link>
                  </div>
                </template>
                </b-table>
                  <span class="total-label">Total Payment:</span>
                  <span class="total-value">{{commas (totalPayment) }}  </span>

                  <span class="total-label">  Total Paid:</span>
                  <span class="total-value">{{commas (totalPaid) }}</span>

                  <span class="total-label">Total Balance:</span>
                  <span class="total-value">{{commas ( totalBalance ) }}</span>

      
              </div>
              <div class="row">
                <div class="col">
                  <div class="dataTables_paginate paging_simple_numbers float-end">
                    <ul class="pagination pagination-rounded mb-0">
                      <b-pagination v-model="currentPage" :total-rows="List" :per-page="perPage"></b-pagination>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <b-modal id="view-pay" centered :title="acc_name" title-class="font-14" hide-footer>
       <form @submit.prevent="addPayment">
            <div class="form-group mb-2">
            <label>Amount Paid</label>
            <input v-model="balance" readonly type="number" class="form-control"/>
            </div>
            <label>Payment Method</label>
            <multiselect v-model="payment_method" :options="paymentoptions" label="name"></multiselect>
            <div class="form-group mb-2">
            <label>Pay Date</label>
            <input v-model="paydate" type="date" class="form-control"/>
            </div>
            <div class="form-group d-flex justify-content-end">
                <b-button type="button" class="btn w-30" variant="secondary" @click="$bvModal.hide('view-pay')" >Close</b-button>
                <b-button type="submit" class="btn ms-1 w-30" variant="primary" ><i class="fas fa-check-circle"></i> Submit</b-button>
            </div>
        </form>
    </b-modal>

    </Layout>
  </template>
  
  <script>
  import axios from "axios";
  import Layout from "../../layouts/main";
  import PageHeader from "@/components/page-header";
  import Multiselect from "vue-multiselect";
  import appConfig from "@/app.config";
  import { paymentoptionComputed, paymentoptionMethods, groupaccountMethods, groupaccountComputed,groupaccountinvoiceMethods, groupaccountinvoiceComputed } from "@/state/helpers";
  
  export default {
    page: {
      title: "Group Account Invoice",
      meta: [{ name: "description", content: appConfig.description,},],
    },
    components: {
      Layout,PageHeader,Multiselect
    },
    data() {
      return {
        userData: JSON.parse(localStorage.getItem("user")),
        title: "Group Account Invoices",
        items: [ {text: "Dashboard",to: "/",}, {text: "Group Account Invoices",active: true, }, ],
        TotalRows: 1,
        currentPage: 1,
        perPage: 10,
        Options: [10, 50, 100, 150, 200],
        filter: null,
        todoFilter: null,
        filterOn: [],
        sortDesc: true,
        isBusy: true,
        fields: [
            { key: 'index', label: '#', visible: true },
            { key: 'id', label: 'ID', visible: false },
            { key: 'acc_name', label: 'Account Name', visible: true },
            { key: 'acc_number', label: 'Account Number', visible: true },
            { key: 'payment', label: 'Payments', visible: true },
            { key: 'paid', label: 'Amount Paid', visible: true },
            { key: 'balance', label: 'Balance', visible: true },
          ],
        datefrom: new Date().toLocaleDateString('fr-CA'),
        dateto: new Date().toLocaleDateString('fr-CA'),
        paydate: new Date().toLocaleDateString('fr-CA'),
        acc_name:'',
        acc_number:'',
        balance:'',
        payment_method:'',
      };
    },
    computed: {
      ...groupaccountComputed,
      ...groupaccountinvoiceComputed,
      ...paymentoptionComputed,
      List() { return this.groupaccountinvoices.length; },
      Fields() { return this.fields.filter(field => field.visible) },
      Items() { return this.groupaccountinvoices.map((d) => ({...d }))},
      IsBusy() { let a=false; if (this.groupaccountinvoices.length>0) { a=false;} else { a=true;} return a },
      totalPayment() { return this.Items.reduce((total, item) => total + Number(item.payment), 0);},
      totalPaid() { return this.Items.reduce((total, item) => total + Number(item.paid), 0); },
      totalBalance() { return this.Items.reduce((total, item) => { return total + (item.balance > 0 ? item.balance : 0);}, 0);},
    },
    mounted() {
      this.fetchGroupAccounts();
      this.fetchGroupAccountInvoices();
      this.fetchPaymentoptions();
      this.TotalRows = this.groupaccountinvoices.length;
      this.isBusy=false;
    this.payment_method = this.paymentoptions.find(option => option.set_default == 1);
    },
    methods: {
      ...groupaccountMethods,
      ...groupaccountinvoiceMethods,
      ...paymentoptionMethods,
      Filtered(filteredItems) {
        this.TotalRows = filteredItems.length;
        this.currentPage = 1;
      },
    commas(x) { return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','); },
      FilterData() {
        this.filterGroupAccountInvoices({datefrom:this.datefrom,dateto:this.dateto});
      },
      pay(acc_name,acc_number,balance){
      this.acc_name=acc_name+" - "+acc_number+" Invoice";
      this.acc_number=acc_number;
      this.balance=balance;
      this.$bvModal.show('view-pay')
    },
    async addPayment() { 
      let formData = new FormData();
      formData.append("account_number", this.acc_number);
      formData.append("amount_paid", this.balance);
      formData.append("payment_method", this.payment_method.id);
      formData.append("pay_date", this.paydate);
      let url = "/addgroupaccountpayment";
      await axios.post(url, formData).then((response) => {
      if (response.status == 200) {
          this.fetchGroupAccountInvoices();
          this.$bvModal.hide('view-pay');
          this.balance="";
          this.paydate="";
          this.$toast.success("Invoice Payment Added");
      }
      });
    },
    },
  };
  </script>

<style scoped>
.total-label {
  margin-right: 10px; 
}

.total-value {
  font-weight: bold;
  margin-right: 20px; 
}
</style>